import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getUsuario } from "@/api/usuarios";
import { PermisosEditor } from "@/components/features/usuarios/PermisosEditor";
import { InvalidIdNotice } from "@/components/ui/InvalidIdNotice";

export const RolPermisosPage = () => {
  const { id } = useParams<{ id: string }>();
  const rolId = Number(id);
  const navigate = useNavigate();

  if (!Number.isFinite(rolId)) {
    return <InvalidIdNotice label="ID de rol" />;
  }
  return (
    <PermisosEditor
      mode="rol"
      targetId={rolId}
      title="Permisos del rol"
      subtitle="Marca los permisos que este rol otorga a sus usuarios."
      onSaved={() => navigate("/usuarios/roles")}
    />
  );
};

export const UsuarioPermisosPage = () => {
  const { id } = useParams<{ id: string }>();
  const userId = Number(id);
  const navigate = useNavigate();

  const { data: usuario } = useQuery({
    queryKey: ["usuario", userId],
    queryFn: () => getUsuario(userId),
    enabled: Number.isFinite(userId),
  });

  if (!Number.isFinite(userId)) {
    return <InvalidIdNotice label="ID de usuario" />;
  }

  return (
    <PermisosEditor
      mode="usuario"
      targetId={userId}
      title="Permisos del usuario"
      subtitle={
        usuario
          ? `Permisos adicionales para ${usuario.nombre} (se suman a los de su rol).`
          : "Permisos individuales del usuario."
      }
      onSaved={() => navigate("/usuarios")}
    />
  );
};